export const formatDateWithTimezone = (
    date?: string | null,
    timezone?: string | null
): string | null => {
    if (!date || !timezone) {
        return null;
    }

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
        return null;
    }

    try {
        return parsedDate.toLocaleDateString('en-US', {
            timeZone: timezone,
        });
    } catch {
        return null;
    }
};
